import React, { PureComponent, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Card, CardBody, Label, Button } from 'reactstrap';
import ReactTable from 'react-table';
import Select from 'react-select';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import thousands from 'thousands';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import DataTablePagination from 'Components/DataTables/pagination';
import CustomSelectInput from 'Components/CustomSelectInput';
import {
	couponsFindAllByPageAndOptions,
	couponsGetOptions,
	errorReset,
} from 'Redux/actions';
import * as couponsReducer from 'Redux/coupons/reducer';
import IntlMessages from 'Util/IntlMessages';

const STATUS_OPTIONS = [
	{ value: '', label: 'All' },
	{ value: 'C', label: 'C - Cancelled' },
	{ value: 'M', label: 'M - Modified' },
	{ value: 'N', label: 'N - New' },
	{ value: 'R', label: 'R - Redeemed' },
];

class PageCoupons extends PureComponent {
	constructor() {
		super();
		this.state = {
			keyword: '',
			status: null,
			effectiveDateFrom: null,
			effectiveDateTo: null,
			expiryDateFrom: null,
			expiryDateTo: null,
			isCashCoupon: null,
			bonusType: null,
			tableState: {},
		};
		this.breadcrumb = [
			{ id: 'menu.coupon', href: '/coupon/list' },
		];
		this.columns = [
			{
				id: 'br_no',
				Header: 'Coupon No.',
				accessor: (d) => (
					<NavLink to={`/app/coupon/edit/${encodeURIComponent(d.br_no)}`}>
						{d.br_no}
					</NavLink>
				),
			},
			{
				id: 'br_status',
				Header: 'Status',
				width: 80,
				accessor: (d) => {
					switch (d.br_status) {
					case 'C':
						return 'C - Cancelled';
					case 'M':
						return 'M - Modified';
					case 'N':
						return 'N - New';
					case 'R':
						return 'R - Redeemed';
					default:
						return d.br_status;
					}
				},
			},
			{
				id: 'coupon_amt',
				Header: 'Amount',
				width: 100,
				accessor: (d) => {
					if (d.coupon_amt === null || d.coupon_amt === undefined) return '';
					const prefix = d.discount_type === '1' ? '' : '$';
					const suffix = d.discount_type === '1' ? '%' : '';
					return `${prefix}${thousands(Math.round(d.coupon_amt) || 0)}${suffix}`;
				},
			},
			{
				Header: 'Description',
				accessor: 'statement_desc',
			},
			{
				id: 'coupon_type',
				Header: 'Cash Coupon',
				width: 100,
				accessor: (d) => (d.is_cash_coupon ? 'Yes' : 'No'),
			},
			{
				id: 'br_date',
				Header: 'Effective Date',
				width: 110,
				accessor: (d) => (d.br_date ? moment(d.br_date).format('YYYY-MM-DD') : ''),
			},
			{
				id: 'expiry_date',
				Header: 'Expiry Date',
				width: 110,
				accessor: (d) => (d.expiry_date ? moment(d.expiry_date).format('YYYY-MM-DD') : ''),
			},
			{
				id: 'promo_ids',
				Header: 'Promo ID',
				width: 120,
				sortable: false,
				accessor: (d) => (d.promo_ids && d.promo_ids.length > 0 ? d.promo_ids.join(', ') : ''),
			},
			{
				id: 'action',
				Header: '',
				width: 50,
				sortable: false,
				accessor: (d) => (
					<NavLink className="btn btn-xs btn-outline-primary" to={`/app/coupon/edit/${encodeURIComponent(d.br_no)}`}>
						<i className="simple-icon-pencil" />
					</NavLink>
				),
			},
		];
		this.fetchData = this.fetchData.bind(this);
		this.onChangeKeywordHandler = this.onChangeKeywordHandler.bind(this);
		this.onChangeStatusHandler = this.onChangeStatusHandler.bind(this);
		this.onChangeIsCashCouponHandler = this.onChangeIsCashCouponHandler.bind(this);
		this.onChangeBonusTypeHandler = this.onChangeBonusTypeHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
	}

	componentDidMount() {
		this.props.errorReset('coupons');
		this.props.couponsGetOptions();
	}

	fetchData(state) {
		const {
			keyword,
			status,
			effectiveDateFrom,
			effectiveDateTo,
			expiryDateFrom,
			expiryDateTo,
			isCashCoupon,
			bonusType,
		} = this.state;

		let params = {
			page: state.page + 1,
			size: state.pageSize,
		};
		if (state.sorted && state.sorted.length > 0) {
			params.sort_column = state.sorted[0].id;
			params.sort_direction = state.sorted[0].desc ? 'desc' : 'asc';
		}
		if (keyword) {
			params.keyword = keyword;
		}
		if (status && status.value) {
			params.status = status.value;
		}
		if (effectiveDateFrom) {
			params.effective_date_from = moment(effectiveDateFrom).format('YYYY-MM-DD');
		}
		if (effectiveDateTo) {
			params.effective_date_to = moment(effectiveDateTo).format('YYYY-MM-DD');
		}
		if (expiryDateFrom) {
			params.expiry_date_from = moment(expiryDateFrom).format('YYYY-MM-DD');
		}
		if (expiryDateTo) {
			params.expiry_date_to = moment(expiryDateTo).format('YYYY-MM-DD');
		}
		if (isCashCoupon !== null && isCashCoupon !== undefined) {
			params.is_cash_coupon = isCashCoupon;
		}
		if (bonusType && bonusType.value) {
			params.bonus_type = bonusType.value;
		}

		this.setState({ tableState: state });
		this.props.couponsFindAllByPageAndOptions(params);
	}

	onChangeKeywordHandler(e) {
		this.setState({ keyword: e.target.value });
	}

	onChangeStatusHandler(selectedOption) {
		this.setState({ status: selectedOption });
	}

	onChangeIsCashCouponHandler(selectedOption) {
		this.setState({
			isCashCoupon: selectedOption ? selectedOption.value : null,
		});
	}

	onChangeBonusTypeHandler(selectedOption) {
		this.setState({ bonusType: selectedOption });
	}

	onSubmitHandler(e) {
		e && e.preventDefault();
		const { tableState } = this.state;
		this.fetchData(tableState);
	}

	render() {
		const { couponsByPage } = this.props;
		const {
			keyword,
			status,
			effectiveDateFrom,
			effectiveDateTo,
			expiryDateFrom,
			expiryDateTo,
			isCashCoupon,
			bonusType,
		} = this.state;
		const listStatus = this.props.status.get('coupons');
		const isLoading = listStatus === 'fetching';

		const cashCouponOptions = [
			{ value: null, label: 'All' },
			{ value: true, label: 'Yes' },
			{ value: false, label: 'No' },
		];

		const categoryOptions = this.props.options.get('coupon_category') || [];

		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<div className="float-left">
							<BreadcrumbContainer
								heading={<IntlMessages id="coupons.heading" />}
								items={this.breadcrumb}
								match={this.props.match}
							/>
						</div>
						<div className="float-right">
							<NavLink to="/app/coupon/create" className="btn btn-lg btn-primary">
								CREATE NEW
							</NavLink>
						</div>
						<div className="clearfix"></div>

						<form className="mb-3" onSubmit={this.onSubmitHandler}>
							<Row className="align-items-center">
								<Colxx xxs="12" md="3">
									<Label>Coupon No. Search:</Label>
									<div className="search-sm d-inline-block w-100">
										<input
											type="text"
											placeholder="Search"
											className="w-100"
											value={keyword}
											onChange={this.onChangeKeywordHandler}
										/>
									</div>
								</Colxx>

								<Colxx xxs="12" md="3">
									<Label>Status:</Label>
									<Select
										components={{ Input: CustomSelectInput }}
										className="react-select"
										classNamePrefix="react-select"
										value={status}
										isClearable={true}
										onChange={this.onChangeStatusHandler}
										options={STATUS_OPTIONS}
									/>
								</Colxx>

								<Colxx xxs="12" md="3">
									<Label>Cash Coupon:</Label>
									<Select
										components={{ Input: CustomSelectInput }}
										className="react-select"
										classNamePrefix="react-select"
										value={cashCouponOptions.find((o) => o.value === isCashCoupon) || null}
										isClearable={true}
										onChange={this.onChangeIsCashCouponHandler}
										options={cashCouponOptions}
									/>
								</Colxx>

								<Colxx xxs="12" md="3">
									<Label>Apply Shop:</Label>
									<Select
										components={{ Input: CustomSelectInput }}
										className="react-select"
										classNamePrefix="react-select"
										value={bonusType}
										isClearable={true}
										onChange={this.onChangeBonusTypeHandler}
										options={categoryOptions}
									/>
								</Colxx>
							</Row>

							<Row className="align-items-center mt-3">
								<Colxx xxs="12" md="3">
									<Label>Effective Date From:</Label>
									<DatePicker
										selected={effectiveDateFrom}
										onChange={(date) => this.setState({ effectiveDateFrom: date })}
										dateFormat="YYYY-MM-DD"
										placeholderText="From"
										className="form-control"
										isClearable={true}
									/>
								</Colxx>
								<Colxx xxs="12" md="3">
									<Label>Effective Date To:</Label>
									<DatePicker
										selected={effectiveDateTo}
										onChange={(date) => this.setState({ effectiveDateTo: date })}
										dateFormat="YYYY-MM-DD"
										placeholderText="To"
										className="form-control"
										isClearable={true}
									/>
								</Colxx>

								<Colxx xxs="12" md="3">
									<Label>Expiry Date From:</Label>
									<DatePicker
										selected={expiryDateFrom}
										onChange={(date) => this.setState({ expiryDateFrom: date })}
										dateFormat="YYYY-MM-DD"
										placeholderText="From"
										className="form-control"
										isClearable={true}
									/>
								</Colxx>

								<Colxx xxs="12" md="3">
									<Label>Expiry Date To:</Label>
									<DatePicker
										selected={expiryDateTo}
										onChange={(date) => this.setState({ expiryDateTo: date })}
										dateFormat="YYYY-MM-DD"
										placeholderText="To"
										className="form-control"
										isClearable={true}
									/>
								</Colxx>
							</Row>

							<Row className="mt-3">
								<Colxx xxs="12" className="text-right">
									<Button color="primary" type="submit">
										Search
									</Button>
								</Colxx>
							</Row>
						</form>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<Row>
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<ReactTable
									manual
									data={couponsByPage.get('data')}
									pages={couponsByPage.get('total_pages')}
									loading={isLoading}
									onFetchData={this.fetchData}
									columns={this.columns}
									minRows={0}
									showPageJump={true}
									showPageSizeOptions={true}
									PaginationComponent={DataTablePagination}
								/>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

export default connect(
	couponsReducer.selector,
	{
		couponsFindAllByPageAndOptions,
		couponsGetOptions,
		errorReset,
	}
)(PageCoupons);
